<template>
  <div class="n_member">
    <div class="n_top"></div>
    <div class="n_content">
      <div class="n_emit">
        <div>
          <span class="iconfont iconxiugaitouxiang"></span>
          <span>总粉丝数{{count.all_num}}</span>
        </div>
        <div class="n_num">
          <div>
            <p class="n_name">今日新增</p>
            <p class="n_number">{{count.today_num}}</p>
          </div>
          <div>
            <p class="n_name">昨日新增</p>
            <p class="n_number">{{count.yesterday_num}}</p>
          </div>
          <div>
            <p class="n_name">本月新增</p>
            <p class="n_number">{{count.month_num}}</p>
          </div>
          <div>
            <p class="n_name">上月新增</p>
            <p class="n_number">{{count.last_month_num}}</p>
          </div>
        </div>
      </div>
    </div>
    <van-search
      class="margin_top"
      v-model="keywords"
      shape="round"
      background="rgba(249, 249, 249, 1)"
      placeholder="请输入搜索关键词"
      @input="inputFg"
    />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getOnLoad"
      :immediate-check="false"
    >
      <div class="n_list" v-for="item in list" :key="item.id" @click="jump(item.id)">
        <img :src="item.avatar" alt />
        <div>
          <div class="name_user">{{item.nick_name}}</div>
          <div class="n_time">最近一次购买：{{ item.order_at > 0 ? item.order_at_text : '用户暂无购买记录'}}</div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      keywords: '',
      list: [],
      count: {},
    }
  },
  created() {
    this.getList()
    this.memberCount()
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    jump(id) {
      this.$router.push({ path: './memberDetail', query: { id: id } })
    },
    async memberCount() {
      let res = await this.http('ClientMember.memberCount', {})
      console.log(res)
      this.count = res.content
    },
    async getList() {
      let res = await this.http('ClientMember.memberList', {
        page: this.page,
        limit: 10,
        keywords: this.keywords,
      })
      this.loading = false
      this.list = this.list.concat(res.content.list)
      this.finished = this.list.length == res.content.count
      console.log(res)
    },
    inputFg() {
      this.page = 1
      this.list = []
      this.getList()
    },
    getOnLoad() {
      console.log(222222)
      this.page++
      this.getList()
    },
  },
}
</script>
<style scoped>
.van-search__content {
  margin-top: 100px;
  background: #fff;
}
</style>
<style lang="scss" scoped>
.name_user {
  width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.n_time {
  font-size: 26px;
  color: #969799;
  margin-top: 12px;
}
.n_member {
  min-height: 100vh;
  background: rgba(249, 249, 249, 1);
}
.n_top {
  background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yi_redbg1.png')
    no-repeat top;
  background-size: 100% 300px;
  height: 300px;
}
.n_content {
  position: absolute;
  top: 140px;
  left: 0;
  right: 0;
  padding: 0 20px;
}
.n_emit {
  padding: 50px 32px 30px 40px;
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
}
.iconxiugaitouxiang {
  margin-right: 3px;
  font-size: 30px;
}
.n_name {
  font-size: 24px;
  color: #999999;
}
.n_number {
  font-size: 38px;
  color: #333333;
}
.n_num {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
}
.n_list {
  display: flex;
  align-items: center;
  width: 710px;
  height: 148px;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(136, 136, 136, 0.05);
  border-radius: 16px;
  margin: 0 auto 20px;
}
.n_list img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 20px;
  margin-left: 20px;
}
.margin_top {
  margin-top: 20px;
}
</style>